class FadeUp {
  constructor() {
    this.init();
  }

  init() {
    const initObserver = () => {
      const animateGroups = document.querySelectorAll(".js-fade-group");
      
      if (animateGroups.length === 0) return;

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Cerchiamo gli elementi js-fade-up SOLO all'interno del gruppo intercettato
              const fadeItems = entry.target.querySelectorAll(".js-fade-up");
              
              fadeItems.forEach((item, index) => {
                item.style.transitionDelay = `${index * 0.15}s`;
                requestAnimationFrame(() => {
                  item.classList.add("is-visible");
                });
              });

              // Smettiamo di osservare questo specifico gruppo
              obs.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15 // Regola questo valore a piacimento (0.15 = 15% visibile)
        }
      );

      animateGroups.forEach((group) => {
        observer.observe(group);
      });
    };

    // Assicuriamoci che il DOM sia pronto
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initObserver);
    } else {
      initObserver();
    }
  }
}

export default FadeUp;